import * as T from "./types";

export const defaultState: T.Store = {
  benchmark: {},
  performance: {
    uniqueCountry: [],
    sector: [],
    industry: [],
    stock: []
  },
  meta: {
    benchmarkExchanges: []
  },
  status: {
    benchmark: "SUCCESS",
    performance: "SUCCESS",
    meta: "SUCCESS"
  }
};
